/**
 * A tiny pseudo-random number generator (PRNG), called "mulberry32".
 *
 * `Math.random()` gives different numbers every time, which would make every
 * level different on every run. This function instead takes a starting number
 * (the "seed") and returns a function that produces the same sequence of
 * numbers between 0 and 1 for that seed, every time. Using it is what makes
 * "level 12" the same board for every player, and makes tests repeatable.
 *
 * The bit operations inside are the published algorithm; you don't need to
 * follow them to use it. It's fast and good enough for games, but not suitable
 * for anything security-related.
 */
export function mulberry32(seed: number): () => number {
	let a = seed >>> 0;
	return () => {
		a = (a + 0x6d2b79f5) >>> 0;
		let t = a;
		t = Math.imul(t ^ (t >>> 15), t | 1);
		t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
		return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
	};
}
